import React from "react"
import styled from "styled-components"
import { Seo } from "../../components/seo"
import Hero from "./hero"
import DoItAllWithClearout from "./do-it-all-with-clearout"
import TrustedByBusinesses from "./trusted-by-businesses"
import FeatureDefineAction from "./feature-define-action"
import EmailFinder from "./email-finder"
import EmailFinderMob from "./email-finder-mob"
import QuickEmailVerify from "./quick-email-verify"
import LinkedinchromeExtension from "./linkedin-chrome"
import DataSecurity from "./data-security"
import Testimonials from "./testimonials"
import ApiForDevelopers from "./api-for-developers"
import CreateFreeAccount from "../../components/create-free-account"
import FixedBadge from "../../components/externals/fixedbadge"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import EfficientServices from "../../components/efficient-services-badges/efficient-service"

const StyledHome = styled("div")`
  .hero-section {
    background-image: linear-gradient(
      to right,
      #f6ece0,
      #f5eee4,
      #f4f0e7,
      #f4f1eb,
      #f4f3ef,
      #f7f4f2,
      #f8f5f5,
      #f8f7f7,
      #faf9f9,
      #fbfbfb,
      #fdfdfd,
      #ffffff
    );
    background-size: 100% 100%;
  }

  .trust-try-it-now-section {
    background-color: #f5f5f582;
    color: #4a4560 !important;
  }

  .do-it-all-with-clearout {
    background-color: #fff;
  }

  .validation-check-that-define-accuracy {
    background-color: #0c092d !important;
  }

  .api-for-developers {
    background-color: #0a2540;
    color: #eeefebde !important;
  }

  .create-free-account {
    background-color: #fff !important;
  }

  .patch {
    background-color: #fff;
    height: 150px;
    position: absolute;
    width: 100%;
    bottom: -72px;
  }

  .custom-shape-divider-top-1679149298 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
  }

  .custom-shape-divider-top-1679149298 svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: 76px;
    transform: rotateY(180deg);
  }

  .custom-shape-divider-top-1679149298 .shape-fill {
    fill: #ffffff;
  }

  .custom-shape-divider-top-1678277261 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    line-height: 0;
    transform: rotate(180deg);
  }

  .custom-shape-divider-top-1678277261 svg {
    position: relative;
    display: block;
    width: calc(100% + 1.3px);
    height: 32px;
  }

  .custom-shape-divider-top-1678277261 .shape-fill {
    fill: #ffffff;
  }

  @media (max-width: 991px) {
    .tab-content > .tab-pane {
      display: block;
      opacity: 1;
    }

    .tab-content > .tab-pane > .collapse {
      display: block;
    }

    .do-it-all-with-clearout .container {
      padding: 10px !important;
      text-align: center;
    }

    .py-5 {
      padding-top: 2rem !important;
      padding-bottom: 2rem !important;
    }

    .pb-5 {
      padding-bottom: 2rem !important;
    }

    .patch {
      background-color: #fff;
      height: 70px;
      position: absolute;
      width: 100%;
      bottom: -35px;
    }
  }

  @media only screen and (max-width: 600px) {
    .email-finder {
      display: none;
    }

    .align-center {
      text-align: center;
    }
  }

  @media only screen and (min-width: 1200px) {
    .email-finder-mob {
      display: none;
    }
  }

  @media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    .email-finder-mob {
      display: none;
    }
  }

  @media only screen and (min-width: 992px) {
    .email-finder-mob {
      display: none;
    }
  }
`

const HomePage = () => {
  return (
    <StyledHome>
      <FixedBadge />

      <section className="pt-4 hero-section">
        <Hero />
      </section>
      <section
        className="pt-4 trust-try-it-now-section"
        style={{ position: "relative" }}
      >
        <div className="custom-shape-divider-top-1679149298">
          <svg
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M1200 120L0 16.48 0 0 1200 0 1200 120z"
              className="shape-fill"
            ></path>
          </svg>
        </div>
        <div style={{ paddingTop: "40px" }}>
          <TrustedByBusinesses />
        </div>
      </section>
      <section className="py-4 do-it-all-with-clearout pt-5">
        <DoItAllWithClearout />
      </section>
      <section className="py-4 feature-that-define-our-actions" id="features">
        <FeatureDefineAction />
      </section>
      <section className="py-5 linkedin-chrome-section">
        <LinkedinchromeExtension />
      </section>
      <section className="py-5 email-finder">
        <EmailFinder />
      </section>
      <section className="email-finder-mob">
        <EmailFinderMob />
      </section>
      <section className="py-5 instant-email-verification">
        <QuickEmailVerify />
      </section>
      <section className="py-5 efficient-with-certified-accreditation">
        <EfficientServices />
      </section>
      <section className="py-4 data-security">
        <DataSecurity />
      </section>
      <section className="py-4 testimonials">
        <Testimonials />
      </section>
      <section className="py-5 api-for-dev-section" id="developers">
        <ApiForDevelopers />
      </section>
      <section className="py-5 create-free-account">
        <CreateFreeAccount />
      </section>
    </StyledHome>
  )
}

export default HomePage

export const Head = () => (
  <Seo
    title="Clearout: Email Validation, Email Finder & Sales Prospecting"
    description="Clearout is a powerful platform that offers email validation, email finder and prospecting services to help businesses find potential customers."
    keywords="clearout, clearout.io, clearout email, clear out, clearout io, clearout email finder, clearout email verifier, cleaout, clerout, clearout api, clearout email verification, clearout email validation, clearout sales prospecting"
  />
)
